var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"widgetContainer"}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.initializeWidget}},[_vm._v("Search")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }